import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Department } from './models/department.model';

export interface DepartmentState extends EntityState<Department, number> {
  parentCompany: CompanyCacheIdentifier[];
}

export interface CompanyCacheIdentifier {
  parentCompanyId: number;
  dateCached: Date;
}

function createInitialState(): DepartmentState {
  return {
    parentCompany: new Array<CompanyCacheIdentifier>()
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'department', idKey: 'DepartmentId', cache: { ttl: 20000 } })
export class DepartmentStore extends EntityStore<DepartmentState> {

  constructor() {
    super(createInitialState());
  }

  addCachedCompany(parentCompanyId: number) {
    let dateCached = new Date();
    let parentCacheIdentifier = { parentCompanyId, dateCached } as CompanyCacheIdentifier;

    this.update(x => {
      let state = {
        parentCompany: x.parentCompany
      };
      state.parentCompany = x.parentCompany.concat([parentCacheIdentifier]);
      return state;
    });
  }
}

